export class AppSignallerService {
    window:any=<any>window;
    notification:any = new this.window.HPNotification({parent: 'body'});
    rand:any = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };
    fileOpener:any = {
        open: function(path, mime = "*/*", name = "", download = true) {
            if(!path) return;
            let anchor = window.document.createElement('a');
            anchor.setAttribute('href', path);
            anchor.setAttribute('target', '_blank');
            if(!!download) anchor.setAttribute('download', name);
            window.document.body.appendChild(anchor);
            anchor.click();
            setTimeout(() => {
                anchor.remove();
            }, 100);
        }
    };
    readFile = (input) => new Promise(async (res:any, rej:any) => {
        let result = [],
            files = input.target.files || [];

        for(const file of files) {
            let file_obj = await new Promise((resolve, reject) => {
                var reader = new FileReader();
                
                reader.onload = (e) => {
                    let format = "",
                        temp_split = file.name?.split(".");
                    if(!!temp_split.length) {
                        format = temp_split[temp_split.length-1];
                    }
                    resolve({
                        content: e.target.result,
                        name: `${this.rand()}.${format}`,
                        filename: file.name,
                        display_name: file.name,
                        mime: this.window.flowup.utils.getMime(file.name),
                        size: file.totalsize,
                        upload_timestamp: 0,

                        // DA SPECIFICARE
                        owner: "",
                        target: "",
                        type: "",
                        tags: []
                    });
                };

                reader.readAsDataURL(file);
            });
            result.push(file_obj);
        }

        res(result);
    });
    upload = (data:any, silentLoader = false, url = `${this.window.appInfo.url_media}/upload.php`) => this.window.sf.utils.$http({
        method: 'POST',
        url: url,
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            private_token : this.window.usher.getPrivateToken(),
            name : data.name,
            content : data.content,
            private : !!data.private,
            onlymine : !!data.onlyMine
        }
    }, silentLoader);

    constructor(
    ) {}

    initService = () => {
        this.window.flowup.signal.target.addEventListener('notification', (ev:any) => {
            let type = ev?.detail?.type || 'success';
            this.notification[type]({text: ev?.detail?.text || ""});
        });

        this.window.flowup.signal.target.addEventListener('open-modal', (ev:any) => {
            let selector = ev?.detail?.selector || "",
                element = ev?.detail?.element || this.window.document;
            if(!selector) return;
            let modal_wrapper = Array.from(element.querySelector(`${selector}`)?.children || []);
            modal_wrapper.forEach((el:any) => {
                el.style.display = 'block';
                el.setAttribute('active', 'true');
            });
            return;
        });

        this.window.flowup.signal.target.addEventListener('close-modal', (ev:any) => {
            let selector = ev?.detail?.selector || "",
                element = ev?.detail?.element || this.window.document;
            if(!selector) return;
            let modal_wrapper = Array.from(element.querySelector(`${selector}`)?.children || []);
            modal_wrapper.forEach((el:any) => {
                el.style.display = 'none';
                el.setAttribute('active', 'false');
            });
            return;
        });

        this.window.flowup.signal.target.addEventListener('open-browser', (ev:any) => {
            let url = ev?.detail?.url || "",
                target = ev?.detail?.target || "_blank";
            if(!url) return;
            this.window.open(url, target);
            return;
        });
        
        this.window.flowup.signal.target.addEventListener('open-file', (ev:any) => {
            let path = ev?.detail?.path || "",
                mime = ev?.detail?.mime || "*/*",
                name = ev?.detail?.name || this.rand(),
                download = ev?.detail?.download !== false;
            if(!path) return;
            this.fileOpener.open(path, mime, name, download);
            return;
        });

        this.window.flowup.signal.target.addEventListener('get-files', async (ev:any) => {
            let types = ev?.detail?.types || this.window.flowup.utils.collectionMimes,
                multiple = !!ev?.detail?.multiple,
                event = ev?.detail?.event || {},
                callback = ev?.detail?.callback || (() => {});
            try {
                let files = await this.readFile(event);
                callback(files);
            } catch(e) {
                console.log(e);
            }
            return;
        });
        
        this.window.flowup.signal.target.addEventListener('upload-files', async (ev:any) => {
            let collection = ev?.detail?.collection || [],
                callback = ev?.detail?.callback || (() => {}),
                error = ev?.detail?.error || (() => {}),
                private_doc = !!ev?.detail?.private,
                onlyMine = !!ev?.detail?.onlyMine,
                url = ev?.detail?.url || undefined,
                silentLoader = !!ev?.detail?.silentLoader,
                sent = [];
                for(const file of collection) {
                    try {
                        let file_sent = await this.upload({
                            name: file?.name,
                            content: file?.content,
                            private: private_doc,
                            onlyMine: onlyMine
                        }, silentLoader, url),
                            result = {
                                ...file,
                                content: undefined,
                                filetype: this.window.flowup.utils.getFileType(file.filename),
                                size: file_sent.size,
                                upload_timestamp: new Date().getTime()
                            };
                        if(!isNaN(file_sent.duration) && file_sent.duration != null) result.duration = +file_sent.duration;
                        sent.push(result);
                    } catch(e) {
                        console.log(e);
                        error(file);
                    }
                }
                callback(sent);
            return;
        });
    };

}